var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThumbsUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "-1 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.438 5.25H.562A.562.562 0 0 0 0 5.813v5.625c0 .31.252.562.563.562h1.875c.31 0 .562-.252.562-.563V5.814a.562.562 0 0 0-.563-.563zM1.5 11.063a.562.562 0 1 1 0-1.125.562.562 0 0 1 0 1.124zM9 1.909c0 .994-.609 1.552-.78 2.216h2.384c.783 0 1.392.65 1.396 1.362.002.42-.177.873-.456 1.153l-.002.002c.23.547.193 1.314-.218 1.863.203.607-.002 1.352-.384 1.752.1.412.052.763-.144 1.046-.479.687-1.664.697-2.667.697h-.067c-1.131 0-2.058-.412-2.802-.744-.374-.166-.863-.372-1.234-.379a.281.281 0 0 1-.276-.281v-5.01a.28.28 0 0 1 .083-.2c.929-.917 1.328-1.889 2.09-2.65.346-.349.472-.874.594-1.381C6.621.92 6.84 0 7.312 0 7.875 0 9 .188 9 1.909z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsUp);
export default __webpack_public_path__ + "static/media/thumbs-up.c941305b435621e8a8970caf0c56085f.svg";
export { ForwardRef as ReactComponent };